module.exports = __webpack_public_path__ + "static/media/icona ricerca clienti.919e6d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icona ricerca clienti.png
// module id = 92
// module chunks = 0